import LinkIcon from './component'
export default LinkIcon
